'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'face-surprise';
var width = 512;
var height = 512;
var aliases = [128558,"surprise"];
var unicode = 'f5c2';
var svgPathData = ['M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm168.4-48a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM336 352a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zm24.4-144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceSurprise = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;